<template>
    <div>
        <div style="width: 50%;margin: 0 auto;">
          <h1>
            DIY Service Contract
          </h1>
          <h3>Please Read!</h3>
          <p>
            If there are any other persons that you are receiving help from or if someone else is paying for the work, make sure they also read this.
          </p>
          <b-card title="Blue Stakes">
            <b-card-text>
              <p>
                If you already have a Blue Stakes number please provide it below.
                If you do not already have a Blue Stakes number that is O.K.
                We will contact them and schedule our service for soon after they are done.
              <p>
              <p>
                Blue Stakes requires all areas within 2 feet of the marks must be dug by hand.
                <span style="font-weight:bold">We will not operate any of our equipment within 2 feet of the marks.</span>
                Do not remove or cover up the markings, if marking has been modified we will not be able to do the work.
              </p>
            </b-card-text>
          </b-card>
          <b-card title="On Site Requirments">
            <b-card-text>
              <p>
                We will need to have someone on-site with us at all times to answer any question we have.
              </p>
              <p>
                Please have everything you want to be done marked with different color paint or flags.
              </p>
              <p>
                Having a drawing that shows what size pipe and where it goes would also help.
                Take a picture or scan drawing and upload it below.
                Again keep all trenches or pipe 2 feet from utility markings.
              </p>
            </b-card-text>
          </b-card>
          <b-card title="Design Help">
            <b-card-text>
              <p>
                If you do need help in laying out the system, let us know.
                For an additional fee, $100 to $200, we can schedule to help you with this a few days before.
              </p>
            </b-card-text>
          </b-card>
          <b-card title="Pricing Terms">
              <b-card-text>
                <p>
                  The time we spend discussing and marking and where to put the trench or pipe will be charged at the rate below.
                  We will charge from the time we pull up to the curb until we load the equipment back onto the trailer.
                  All time will be rounded up to the next 15 minutes.
                </p>
                <p>
                  The piece rates are a guideline for an approximate cost for a job. There are many factors the can change the cost. Lots of short runs will cost more than a few long runs. The prices below are based on non-compacted and non-rocky soil. For compacted or rocky soil the piece rate can double and the hourly rate can be charged up to 50% more for wear and tear on the equipment.
                </p>
                <p>
                  Any cancellation will be billed. Cancellation fee after 24 hours and within 48 hours of returning the information below $50.00. After 48 hours $75.00. If we show up on site, we will bill the Minimum rate.
                </p>
              </b-card-text>
          </b-card>
          <div style="text-align:left;">
               <b-form-group label="I am">
                <b-form-radio name="relationship" value="Owner" required>The owner of the Property</b-form-radio>
                <b-form-radio name="relationship" value="Helping" required>Helping the owner of the property</b-form-radio>
                <b-form-radio name="relationship" value="Contractor" required>A contractor working for the owner</b-form-radio>
              </b-form-group>
          </div>
          <p style="text-align:left;">
            Please select which services you need:
          </p>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.hauling" value="hauling" required>Hauling</b-form-checkbox></b-card-title>
            <b-card-text>
              <p>
                We have flat bed trailer to dump trailer that can bring material to your yard or remove materials from you yard. We can leave the trailer onsite for the day and return to pick it up. Fill out the form below and provide details of what you need hauld for a price estimate.
              </p>
              <p>
                Minimum first 30 minutes $99.00 then hourly $110.00 plus any other fees associated with the hauling and dumping.
              </p>
            </b-card-text>
            
          </b-card>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.excavating" value="excavating" required>Mini Excavating</b-form-checkbox></b-card-title>
            <b-card-text>
              <p>
                The bucket move 1 cubic feet of material per scoop. It can dig a trench upto 4 feet deep or move rocks upto 2 feet in diameter
              </p>
              <p>
                The Bobcat 320 42-inches wide and requires at least a 46-inch gate to access any fenced in area.
              </p>
              <p>
                Minimum first 30 minutes $99.00 then Hourly $110.00
              </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.bucket" value="bucket" required>Tractor Bucket</b-form-checkbox></b-card-title>
            <b-card-text>
              <p>
                The bucket can carry up to ⅓ of a yard of material.
              </p>
              <p>
                Minimum first 30 minutes $99.00 then Hourly $110.00
              </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.trenching" value="trenching" required>Trenching</b-form-checkbox></b-card-title>
            <b-card-text>
              <p>
                The trencher can trench 4-inch wide and up to 30 inches deep.
                When laying out where you want the trenches, please keep the trench 2 feet away from any Blue Stakes lines, 30 inches from any wall or fence areas and 6 inches away from concrete.
                All trenches will need to be straight as the trencher cannot make turns.
                The equipment is about 10 feet long, trenches ending and/or starting against the fence and/or wall will end 10 feet from the fence or wall.
                Hard or rocky ground will take longer.
                On average we can trench about 500 feet per hour.
              </p>
              <p>
                The Ditch Witch 850 is 42-inches wide and requires at least a 46-inch gate to access any fenced in area.
              </p>
              <p>
                The equipment has a 2-foot offset so we can’t get closer than 30 inches to any fence, wall or other objects. When trenching or pipe pulling next to concrete, we will keep our equipment at least 6 inches from the concrete.
              </p>
              <p>
                Minimum first 30 minutes $122.00 then Hourly $135.00
              </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.pipe_pulling" value="pipe_pulling" required>Pipe Pulling</b-form-checkbox></b-card-title>
            <b-card-text>
                <p>
                  The puller can pull wire, PVC and Poly pipe up to 2 inches in size and up to 18 inches deep
                </p>
                <p>
                  We will assume that you will provide the pipe. It is best to get the 400-foot rolls of poly pipe. If you want us to provide the pipe, we can for addtional cost of the pipe, please let us know what you will need. When pulling PVC pipe, please have pipe glued together and cut to length before we arrive. When having us pull wire, make sure you have at least 10 feet more wire than you need
                </p>
                <p>
                  When laying out where you want the pipe pulled, please keep 2 feet away from any Blue Stakes lines, 30 inches from any wall or fence areas and 6 inches away from concrete.
                </p>
                <p>
                  The pipe puller can make turns of a 12 foot radius or larger, any turns/curbs that are smaller the pipe will be placed on top of the ground. It is better to cut the pipe and use a elbow or coupler to make the turn.
                </p>
                <p>
                  The equipment is about 10 feet long, pipe ending and/or starting against the fence and/or wall will end 10 feet from the fence or wall.
                  The shorter the pipe pulled the more time it takes to pull per foot. If you have a small yard, it is going to cost more per foot than a larger yard with longer runs.
                  Hard or rocky ground will take longer and may not be as deep.
                  On average we can pull about 1,000 feet per hour.
                </p>
                <p>
                  The equipment has a 2-foot offset so we can’t get closer than 30 inches to any fence, wall or other objects. When trenching or pipe pulling next to concrete, we will keep our equipment at least 6 inches from the concrete.
                </p>
                <p>
                  Minimum first 30 minutes $167.00 then Hourly $185.00
                </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.boring" value="boring" required>Directional Boring</b-form-checkbox></b-card-title>
            <b-card-text>
              <p>
                Directional boring can be done up to 20 feet and up to a 4-inch hole.
              </p>
              <p>
                To prepare for directional boring, an 18-inch wide equipment trench needs to be dug back from the area to be bored 8 feet. It needs to be 6 inches deeper than the bore needs to be, this should be at least 18 inches deep. We can dig this equipment trench if you request for us to do so.
              </p>
              <ul>
                <li>4-foot sidewalk cost with equipment trench already dug $95.00</li>
                <li>20-foot driveway with the equipment trench already dug around $150.00 - $200.00</li>
              </ul>
                <p>
                  Minimum first 30 minutes $95.00 then Hourly $125.00
                </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-title><b-form-checkbox v-model="request.services.augering" value="augering" required>Augering</b-form-checkbox></b-card-title>
            <b-card-text>
              <p>            
                9 or 12-inch holes can be drilled up to 42-inches deep.
                Have the center of the hole marked with paint.
              </p>
              <p>
                Minimum first 30 minutes $95.00 then Hourly $125.00
              </p>
            </b-card-text>
          </b-card>
          <h3>Billing Information</h3>
            <b-container fluid>
              <b-row class="my-1">
                <b-col sm="3">
                  <label for="name">Name</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input id="name" placeholder="John Doe" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="3">
                  <label for="address">Address</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input id="address" placeholder="123 Main Street" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="3">
                  <label for="city">City</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="city" placeholder="Layton" required></b-form-input>
                </b-col>
                <b-col sm="1">
                  <label for="state">State</label>
                </b-col>
                <b-col sm="2">
                  <b-form-input id="state" placeholder="UT" required></b-form-input>
                </b-col>
                <b-col sm="1">
                  <label for="zip">ZIP</label>
                </b-col>
                <b-col sm="2">
                  <b-form-input id="zip" placeholder="84020" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="3">
                  <label for="phone">Phone</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input id="phone" placeholder="801 555-5555" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="3">
                  <label for="email">Email</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input id="email" placeholder="johnd@example.com" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="9">
                  <label for="existing">Is this a new or an exsting yard, is there dirt or grass?</label>
                </b-col>
                <b-col sm="3">
                    <b-form-radio id="existing" name="existing" value="dirt" required>Dirt</b-form-radio>
                    <b-form-radio id="existing" name="existing" value="grass" required>Grass</b-form-radio>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="9">
                  <label for="name">Which part of the yard will be working in?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-radio id="part" name="part" value="entire" required>Entire</b-form-radio>
                  <b-form-radio id="part" name="part" value="front" required>Front</b-form-radio>
                  <b-form-radio id="part" name="part" value="back" required>Back</b-form-radio>
                  <b-form-radio id="part" name="part" value="side" required>Side</b-form-radio>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col>
                  <label for="properties">Will we be working in any adjacent properties or on the property line? Please describe below.</label>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col>
                  <textarea id="properties"></textarea>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="9">
                  <label for="ticket">Do you have a Blue Stakes ticket number?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-radio id="part" name="ticket" value="yes" required>Yes</b-form-radio>
                  <b-form-radio id="part" name="ticket" value="no" required>No</b-form-radio>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="9">
                  <label for="ticket_number">What is the ticket number?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="ticket_number"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="9">
                  <label for="ticket_phone_number">What phone number was used for the ticket?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="ticket_phone_number" placeholder="801 555-5555" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="9">
                  <label for="date">What date will you be ready?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="date" type="date" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" v-show="request.services.trenching || request.services.excavating">
                <b-col sm="9">
                  <label for="feet_trenched">How many feet do you need trenched?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="feet_trenched" type="number"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" v-show="request.services.trenching || request.services.excavating">
                <b-col sm="9">
                  <label for="deep_trench">How deep will you need your trench?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="deep_trench" type="number"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" v-show="request.services.piping">
                <b-col sm="9">
                  <label for="feet_pipe">How many feet of pipe do you need to be pulled?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="feet_pipe" type="number"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" v-show="request.services.piping">
                <b-col sm="9">
                  <label for="deep_pipe">How deep will you need your pipe?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="deep_pipe" type="number"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" v-show="request.services.boring">
                <b-col sm="9">
                  <label for="name">How many different bores and the length of each?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="bores"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1" v-show="request.services.augering">
                <b-col sm="9">
                  <label for="augers">How many and what size hole will you need to be trilled and how deep?</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="augers" ></b-form-input>
                </b-col>
              </b-row>
                <b-row class="my-1">
                <b-col sm="3">
                  <label for="drawing">Upload drawing</label>
                </b-col>
                <b-col sm="9">
                  <b-form-file id="drawing" placeholder="Choose drawing file"></b-form-file>
                </b-col>
              </b-row>
              <b-row class="my-1">
                  <b-col>
                    <label for="properties">Please tell us when you are available if day or evening work best and what days of the week be the best for you along with Other question or comment</label>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col>
                    <textarea id="comments"></textarea>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="3">
                    <b-button @click="save">Submit</b-button>
                  </b-col>
                </b-row>
          </b-container>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ServicesDIY',
  data() {
    return {
      request: {
        relationship: null,
        services: {
          hauling: false,
          excavating: false,
          bucket: false,
          trenching: false,
          pipe_pulling: false,
          directional_boring: false,
          augering: false
        },
        name: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        phone: null,
        email: null,
        existing: null,
        part: null,
        properties: null,
        ticket: null,
        ticket_number: null,
        ticke_phone: null,
        date: null,
        feet_trenched: null,
        feet_pipe: null,
        deep_trench: null,
        bores: null,
        augers: null,
        drawing: null,
        comments: null
      }
    };
  },
  methods: {
    save() {
      console.log(this.request);
    }
  }
}
</script>